


<template>
  <div class="text-center text-md-left">
    <p class="title-soc-block">{{Lang.get('js.grade')}}:</p>
    <div class="">
      <el-rate v-model="form.value"
         :disabled="!accessRate"
          class="d-inline-block"
         @change="sendRate">
      </el-rate>
      <span class="rate-text d-inline-block">{{Lang.get('js.average')}}: {{averageValue}} ({{count}} {{Lang.get('js.ratings')}})</span>
    </div>

  </div>
</template>

<script>
    export default {
        name: 'rate',
        props: {
            id: {
                required: true,
            },
            type: {
                required: true,
            },
            existedRates: {
                required: false,
            }
        },
        data() {
            return {
                Lang,
                form: new Form({
                    ratable_id: '',
                    ratable_type: '',
                    value: 0,
                }),
                averageValue: 0,
                count: 0,
                accessRate: true,
            }
        },
        methods: {
            sendRate() {
                this.form.post('/send-rate').then(res => {
                    this.count = res.count;
                    this.averageValue = res.averageValue;
                    this.accessRate = false;
                    this.setRateToLocale();
                });
            },
            setRateToLocale() {
                let key = this.form.ratable_id + '_' + this.form.ratable_type;
                localStorage.setItem(key, this.form.value);
            },
            getRateFromLocale() {
                let key = this.form.ratable_id + '_' + this.form.ratable_type;
                this.form.value = Number(localStorage.getItem(key));
                this.accessRate = this.form.value === 0;
            },
            setExistedRates() {
                if(this.existedRates) {
                    this.count = this.existedRates.count;
                    this.averageValue = this.existedRates.avg;
                }
            }
        },
        mounted() {
            this.form.ratable_id = this.id;
            this.form.ratable_type = this.type;
            this.getRateFromLocale();
            this.setExistedRates();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/elements/Rate.vue